import { z } from "zod";
export const FilterLabelsSchema = z.object({
    show: z.string(),
    hide: z.string(),
    reset: z.string(),
});
export const FilterTypeOptionSchema = z.object({
    value: z.union([z.string(), z.number()]),
    label: z.string(),
    selected: z.boolean().optional(),
});
export const SearchFilterTypeSchema = z.object({
    filterType: z.literal("search"),
    type: z.string(),
    label: z.string(),
});
export const SingleSelectFilterTypeSchema = z.object({
    filterType: z.literal("single-select"),
    type: z.string(),
    label: z.string(),
    options: z.array(FilterTypeOptionSchema),
});
export const FilterTypeSchema = z.discriminatedUnion("filterType", [
    SearchFilterTypeSchema,
    SingleSelectFilterTypeSchema,
]);
export const FilterSchema = z.object({
    labels: FilterLabelsSchema,
    filterTypes: z.array(FilterTypeSchema),
});
//# sourceMappingURL=filter.js.map